<div class="settings">
  <main class="settings-content">
    <p>Configure your settings here</p>
  </main>
</div>

